import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import Select, { components } from 'react-select'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function validationIcons(valid) {
	return valid ? (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="exclamation-triangle" />
		</span>
	) : (
		<span className="icon is-small is-right">
			<FontAwesomeIcon icon="check" />
		</span>
	)
}

const DropdownIndicator = props => {
	return (
		components.DropdownIndicator && (
			<components.DropdownIndicator {...props}>
				<FontAwesomeIcon icon="chevron-down" />
			</components.DropdownIndicator>
		)
	)
}

const MyStyles = {
	placeholder: (base, state) => ({
		...base,
		color: 'hsl(0, 0%, 76%)',
		fontWeight: '400',
	}),
	dropdownIndicator: (base, state) => ({
		...base,
		transition: 'all .2s ease',
		transform: state.isFocused ? 'rotate(180deg)' : null,
	}),
	control: (base, { isDisabled, isFocused, isSelected }) => ({
		...base,
		backgroundColor: '#f2fafa',
		borderRadius: 0,
		borderWidth: '2px',
		borderColor: isFocused ? '#e5f0f3' : 'transparent',
		color: 'hsl(0, 0%, 96%)',
		outline: 'none',
		boxShadow: isFocused ? '0 0 0 0.125em rgba(88, 200, 223, 0.25)' : '',
		':hover': {
			borderColor: '#e5f0f3',
		},
	}),
	option: (base, { isDisabled, isFocused, isSelected }) => {
		const dark = '#353e47'
		const blue = '#58c8df'
		return {
			...base,
			backgroundColor: isDisabled
				? null
				: isSelected
					? blue
					: isFocused
						? dark
						: null,
			color: isDisabled
				? '#ccc'
				: isSelected
					? blue
						? 'white'
						: 'black'
					: blue,
			cursor: isDisabled ? 'not-allowed' : 'default',
		}
	},
	multiValue: styles => {
		return {
			...styles,
			backgroundColor: '#353e47',
		}
	},
	multiValueLabel: styles => ({
		...styles,
		color: '#58c8df',
	}),
	multiValueRemove: styles => ({
		...styles,
		color: '#58c8df',
		':hover': {
			backgroundColor: '#353e47',
			color: 'white',
		},
	}),
}

const MySelect = props => {
	const {
		options,
		value,
		errors,
		touched,
		onChange,
		onBlur,
		identity,
		multi,
		placeholder,
		className,
		icon,
	} = props
	const handleChange = value => {
		// this is going to call setFieldValue and manually update values.topics
		onChange(identity, value)
	}

	const handleBlur = () => {
		// this is going to call setFieldTouched and manually update touched.topics
		onBlur(identity, true)
	}
	return (
		<>
			<Select
				id={identity + '-select'}
				name={identity}
				options={options}
				placeholder={placeholder}
				isMulti={multi}
				closeMenuOnSelect={multi ? false : true}
				onChange={handleChange}
				onBlur={handleBlur}
				value={props.value}
				styles={MyStyles}
				components={
					({ DropdownIndicator },
					{
						ValueContainer: ({ children, ...props }) =>
							components.DropdownIndicator && (
								<components.ValueContainer {...props}>
									<span className="icon is-small is-left">
										<FontAwesomeIcon icon={icon} />
									</span>
									{children}
									{touched && errors && validationIcons(true)}
									{value && !errors && validationIcons(false)}
								</components.ValueContainer>
							),
					})
				}
				autoFocus={false}
				className={classNames(
					className,
					touched && errors && `is-danger`,
					value && !errors && `is-success`
				)}
				classNamePrefix="react-select"
			/>
			{touched &&
				errors && (
					<p className="help is-danger" id={`${identity}-helper-text`}>
						{errors}
					</p>
				)}
		</>
	)
}

MySelect.propTypes = {
	multi: PropTypes.bool,
	value: PropTypes.any,
	options: PropTypes.any,
	errors: PropTypes.any,
	onChange: PropTypes.any,
	onBlur: PropTypes.any,
	touched: PropTypes.any,
	identity: PropTypes.string,
	placeholder: PropTypes.any,
	className: PropTypes.any,
	icon: PropTypes.any,
}

export default MySelect
